import { format } from "date-fns";
import { deleteCompanyDepartmentList, deleteCompanyPositionList, deleteCompanySalaryList, getAttendanceDailyWork, getAttendanceDailyWorks, getAttendanceManagement, getAttendanceTag, getAttendanceTagList, getBasicAttendanceList, getBasicDepartmentList, getBasicGrpList, getBasicHolidayList, getBasicInsuranceApplyList, getBasicInsuranceList, getBasicPositionList, getBasicSalaryList, getBasicSimpleTaxList, getBasicTaxList, getBeaconDetail, getBeaconList, postBeaconInsert, getCalcEncpnd, getCalTime, getCodeList, getCompany, getCompanyAttendanceList, getCompanyDepartmentList, getCompanyHolidayList, getCompanyList, getCompanyPositionList, getCompanySalaryList, getCrtlwhTime, getDepartureList, getEmployee, getEmployeeList, getEmployeeSalaryList, getEmployeeWorkTimeFormat, getEmployeeWorkTimeFormatList, getESystemList, getInsuranceRate, getManagerList, getPaymentList, getRetirementPensionList, getSalaryLeaveList, getSalaryManagement, loginAPI, logoutAPI, postAttendanceDailyWork, postAttendanceManagement, postAttendanceTag, postCompanyCreate, postCompanyDepartmentList, postCompanyPositionList, postCompanySalaryList, postEmployeeCreate, postESystemForm, postSalaryManagement, putAttendanceManagement, putCompanyDepartmentList, putCompanyPositionList, putCompanySalaryList, putSalaryManagement, refreshTokenAPI, getBeaconDetailByName, postupdateBeacon, postdeleteBeacon, getMobileList, getMobileDetailByName, postdeleteMobile, getPaymentYearList, getTransferList, getLeavePaymentList, putBasicAttendanceList, putCompanyAttendanceList, postCompanyHolidayList, putCompanyHolidayList, deleteCompanyHolidayList } from "./API";

// Utils
const renameKeys = function (obj, keyMap) {
    /**
    *  dict -> dict 에서 dict key 이름을 변경하는 utils
    */
    let newObj = {};
    Object.keys(obj).forEach(oldKey => {
        if (keyMap[oldKey]) {
            // keyMap[oldKey]가 배열이면 여러 개의 키로 할당
            if (Array.isArray(keyMap[oldKey])) {
                keyMap[oldKey].forEach(newKey => {
                    newObj[newKey] = obj[oldKey];
                });
            } else {
                // 단일 키로 할당
                newObj[keyMap[oldKey]] = obj[oldKey];
            }
        } else {
            // 맵핑되지 않은 키도 포함시키고 싶다면 이 부분에서 추가
            newObj[oldKey] = obj[oldKey];
        }
    });
    return newObj;
};


// Service
// -----------------------------------------------
// Common
// -----------------------------------------------
export const loginService = (data) => {
    /**
     * 로그인
     */
    return loginAPI(data)
}

export const logoutService = (refreshToken, token) => {
    /**
     * 로그아웃
     */
    return logoutAPI(refreshToken, token)
}

export const refreshTokenService = (refreshToken, token) => {
    /**
     * 토큰 갱신
     */
    return refreshTokenAPI(refreshToken, token)
}

export const fetchCodeList = (code_list) => {
    /**
     * 코드 목록 반환
     */
    return getCodeList(code_list)
}

export const fetchEmployeeSalaryList = (employeeNo, paymentType) => {
    /**
     * 사원 급여 목록 반환
     */
    return getEmployeeSalaryList(employeeNo, { paymentType: paymentType })
}

export const fetchEmployeeWorkTimeFormat = (employeeNo, workYM, paymentType) => {
    /**
     * 사원 근무 시간 포맷 목록 반환
     */

    if (paymentType === "0001" || paymentType === undefined) {
        if (workYM === undefined) {
            workYM = format(new Date(), "yyyy-MM");
        }
        return getEmployeeWorkTimeFormat(employeeNo, workYM)
    } else {
        return []
    }


}

export const fetchEmployeeWorkTimeFormatList = (workYM) => {
    /**
     * 사원 근무 시간 포맷 목록 반환
     */
    if (workYM === undefined) {
        workYM = format(new Date(), "yyyy-MM");
        return getEmployeeWorkTimeFormatList(workYM)
    } else {
        return getEmployeeWorkTimeFormatList(workYM)
    }
}

export const fetchCrtlwhTime = (startTime, endTime) => {
    /**
     * 근무시간 조회
     */
    if (startTime && endTime) {
        const startTimeFormat = format(startTime, 'HH:mm')
        const endTimeFormat = format(endTime, 'HH:mm')

        return getCrtlwhTime(startTimeFormat, endTimeFormat)
    } else {
        return new Promise((resolve, reject) => {
            reject(new Error('startTime 또는 endTime이 없습니다.'))
        })
    }
}

// -----------------------------------------------
// Management
// -----------------------------------------------
export const fetchAllCompany = () => {
    /**
     * 회사 목록 반환
     */
    return getCompanyList()
}

export const fetchCompanyMenuItems = async () => {
    /**
     * 회사 목록 MenuItems 형태로 반환
     */
    try {
        const data = await getCompanyList(); // API 호출
        const menuItemKeyMap = { companyNo: ['key', 'value'], companyName: 'text' };
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap))

        return menuItems
    } catch (error) {
        console.error("회사 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompany = (corp_no) => {
    /**
     * 회사 조회
     */
    return getCompany(corp_no)
}

export const fetchCompanyName = async (corp_no) => {
    /**
     * 회사 이름 조회
     */
    const resp = await getCompany(corp_no)
    if (resp.companyName) {
        return resp.companyName
    } else {
        return '회사명을 찾지 못함'
    }
}

export const createCompany = (formData) => {
    /**
     * 회사 생성
     */
    const transformedData = {
        companyName: formData.companyName || undefined,
        companyBusinessNo: formData.companyBusinessNo || undefined,
        companyAddr: formData.companyAddr || undefined,
        companyTel: formData.companyTel || undefined,
        companyEmail: formData.companyEmail || undefined,
        companyOwnerName: formData.companyOwnerName || undefined,
        companyOwnerTel: formData.companyOwnerTel || undefined,
        companyBusinessScale: formData.companyBusinessScale || undefined,
        companyBusinessScaleNum: formData.companyBusinessScaleNum || undefined,

        companyBasic1: formData.companyBasic1 || undefined,
        companyBasic2: formData.companyBasic2 || undefined,
        companyBasic3: formData.companyBasic3 || undefined,
        companyBasic4: formData.companyBasic4 || undefined,

        managerName: formData.managerName || undefined,
        managerId: formData.managerId || undefined,
        managerDepartment: formData.managerDepartment || undefined,
        managerPosition: formData.managerPosition || undefined,
        managerTel: formData.managerTel || undefined,
        managerEmail: formData.managerEmail || undefined,
        managerTelPhone: formData.managerTelPhone || undefined,

        contractType: formData.contractType || undefined,
        // format(formData.workDate, 'yyyy-MM-dd')
        contractStrDate: formData.contractStrDate ? formData.contractStrDate.toISOString().split('T')[0] : undefined,
        contractEndDate: formData.contractEndDate ? formData.contractEndDate.toISOString().split('T')[0] : undefined,
        contractPaymentDate: formData.contractPaymentDate ? formData.contractPaymentDate.toISOString().split('T')[0] : undefined,

        beaconYN: formData.beaconYN || undefined,
        beaconCount: formData.beaconCount || undefined,

        companyBaseTime: formData.companyBaseTime || undefined,

        companyRemark: formData.companyRemark || undefined,
        logoFile: formData.logoFile || undefined,

        companyRetirementPension: formData.companyRetirementPension || undefined,
        companyRetirementPensionAccount: formData.companyRetirementPensionAccount || undefined,
        companyRetirementPensionName: formData.companyRetirementPensionName || undefined,
        companyRetirementPensionBank: formData.companyRetirementPensionBank || undefined,
    };

    // 빈 값이 아닌 데이터만 전송
    const filteredData = Object.fromEntries(Object.entries(transformedData).filter(([_, v]) => v !== undefined));

    const resp = postCompanyCreate(filteredData);

    return resp;
}

export const fetchAllGRPInfo = () => {
    /**
     * 기초 그룹 목록 반환
     */
    return getBasicGrpList()
}

export const fetchAllGRPInfoMenuItems = async () => {
    /**
     * 기초그룹 목록 MenuItems 형태로 만들어서 반환(Select에 사용)
     * 확실한 resp 목록 반환
     */
    // grp info를 menuItems 형태로 반환 { key: '', value: '', text: '' },
    try {
        const data = await getBasicGrpList(); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], grpType: 'grp_type', grpNm: 'text' };
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap))

        return menuItems
    } catch (error) {
        console.error("기초그룹 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchBasicPositionList = (grp_no) => {
    /**
     * 기초 직위 목록 반환
     */
    return getBasicPositionList(grp_no)
}

export const fetchBasicPositionMenuItems = async (grp_no) => {
    /**
    * 기초 그룹 목록 중 직책 MenuItems 형태로 만들어서 반환(Select에 사용)
    * 확실한 resp 목록 반환
    */
    try {
        const data = await getBasicPositionList(grp_no); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], boglVal: 'text' };
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap))

        return menuItems
    } catch (error) {
        console.error("직위 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchBasicDepartmentList = (grp_no) => {
    /**
     * 기초 부서 목록 반환
     */
    return getBasicDepartmentList(grp_no)
}

export const fetchBasicDepartmentMenuItems = async (grp_no) => {
    /**
    * 기초 그룹 목록 중 부서 MenuItems 형태로 만들어서 반환(Select에 사용)
    * 확실한 resp 목록 반환
    */
    try {
        const data = await getBasicDepartmentList(grp_no); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], boglVal: 'text' };
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap))

        return menuItems
    } catch (error) {
        console.error("부서 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchBasicInsuranceList = () => {
    /**
     * 기초 보험 목록 반환
     */
    return getBasicInsuranceList()
}

export const fetchBasicTaxList = () => {
    /**
     * 기초 소득세율 목록 반환
     */
    return getBasicTaxList()
}

export const fetchBasicSimpleTaxList = () => {
    /**
     * 기초 간이세액표 목록 반환
     */
    return getBasicSimpleTaxList()
}

export const fetchBasicAttendanceList = () => {
    /**
     * 기초 근태 목록 반환
     */
    return getBasicAttendanceList()
}

export const fetchBasicSalaryList = () => {
    /**
     * 기초 급여 목록 반환
     */
    return getBasicSalaryList()
}

export const fetchBasicHolidayList = () => {
    /**
     * 기초 공휴일 목록 반환
     */
    return getBasicHolidayList()
}

export const fetchManagerList = () => {
    /**
     * 관리자 목록 반환
     */
    return getManagerList()
}

export const fetchBasicInsuranceApplyList = () => {
    /**
     * 기초 보험 적용 목록 반환
     */
    return getBasicInsuranceApplyList()
}

// -----------------------------------------------
// HRM
// -----------------------------------------------
export const fetchEmployeeList = (filterData) => {
    /**
     * 사원 목록 반환
     */
    return getEmployeeList(filterData)
}

export const fetchEmployeeMenuItems = async (filterData) => {
    /**
     * 사원 목록 MenuItems 형태로 반환
     */
    try {
        const data = await getEmployeeList(filterData); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'] };
        let menuItems = data.map(item => renameKeys(item, menuItemKeyMap))

        menuItems.map((item) => {
            item.text = item.departmentName + " - " + item.positionName + " - " + item.name;
            return item;
        })

        return menuItems
    } catch (error) {
        console.error("사원 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const createEmployee = (formData, empl_no) => {
    /**
     * 사원 생성
     */

    const transformedData = {
        ...formData,
        mdwkWorkday: formData.mdwkWorkday.join(','),
        encpnd: formData.encpnd ? format(formData.encpnd, 'yyyy-MM-dd') : undefined,
        retireDate: formData.retireDate ? format(formData.retireDate, 'yyyy-MM-dd') : undefined,
        dcexpDate: formData.dcexpDate ? format(formData.dcexpDate, 'yyyy-MM-dd') : undefined,

        baseAtendtime: formData.baseAtendtime ? format(formData.baseAtendtime, 'HH:mm') : undefined,
        baseLvofctime: formData.baseLvofctime ? format(formData.baseLvofctime, 'HH:mm') : undefined,
    }
    // console.log(transformedData)

    return postEmployeeCreate(transformedData, empl_no)
}


export const fetchEmployeeAddCodeListMenuItems = async () => {
    /**
     * 사원 생성 코드 목록 반환
     */
    try {
        const data = await fetchCodeList(["0014", "0015", "0021", "0022", "0023"]); // API 호출
        const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0014 = resp.filter((item) => item.category === "0014" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0015 = resp.filter((item) => item.category === "0015" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0021 = resp.filter((item) => item.category === "0021" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0022 = resp.filter((item) => item.category === "0022" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0023 = resp.filter((item) => item.category === "0023" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))

        return {
            salaryFormItems: menuItems0014,
            employmentFormItems: menuItems0015,
            relationshipItems: menuItems0021,
            bankItems: menuItems0022,
            insuranceItems: menuItems0023,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("사원 추가 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompanyAddCodeListMenuItems = async () => {
    /**
     * 회사 생성 코드 목록 반환
     */
    try {
        const data = await fetchCodeList(["0022", "0024"]); // API 호출
        const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0022 = resp.filter((item) => item.category === "0022" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        const menuItems0024 = resp.filter((item) => item.category === "0024" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))
        return {
            bankItems: menuItems0022,
            retirementPensionItems: menuItems0024,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("사원 추가 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}


export const fetchEmployee = (empl_no) => {
    /**
     * 사원 조회
     */
    return getEmployee(empl_no)
}

// -----------------------------------------------
// Company ( Basic Info )
// -----------------------------------------------
export const fetchCompanyDepartmentList = (corp_no) => {
    /**
     * 회사 부서 목록 반환
     */
    return getCompanyDepartmentList(corp_no)
}

export const createCompanyDepartment = (apiData) => {
    /**
     * 회사 부서 목록 생성
     */
    return postCompanyDepartmentList(apiData)
}

export const updateCompanyDepartment = (apiData) => {
    /**
     * 회사 부서 목록 수정
     */
    return putCompanyDepartmentList(apiData)
}

export const deleteCompanyDepartment = (apiData) => {
    /**
     * 회사 부서 목록 삭제
     */
    return deleteCompanyDepartmentList(apiData)
}


export const fetchCompanyDepartmentMenuItems = async (corp_no) => {
    /**
     * 회사 부서 목록 MenuItems 형태로 반환
     */
    try {
        const data = await fetchCompanyDepartmentList(corp_no); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], deptNm: 'text' };
        // console.log(data);
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap));
        return menuItems; // Promise 반환
    } catch (error) {
        console.error("부서 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
};

export const fetchCompanyPositionList = (corp_no) => {
    /**
     * 회사 직위 목록 반환
     */
    return getCompanyPositionList(corp_no)
}

export const createCompanyPosition = (apiData) => {
    /**
     * 회사 직위 목록 생성
     */
    return postCompanyPositionList(apiData)
}

export const updateCompanyPosition = (apiData) => {
    /**
     * 회사 직위 목록 수정
     */
    return putCompanyPositionList(apiData)
}

export const deleteCompanyPosition = (apiData) => {
    /**
     * 회사 직위 목록 삭제
     */
    return deleteCompanyPositionList(apiData)
}

export const fetchCompanyPositionMenuItems = async (corp_no) => {
    /**
     * 회사 직위 목록 MenuItems 형태로 반환
     */
    try {
        const data = await fetchCompanyPositionList(corp_no); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], ofcpsNm: 'text' };
        // console.log(data);
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap));
        return menuItems; // Promise 반환
    } catch (error) {
        console.error("직위 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompanyAttendanceList = (corp_no, type) => {
    /**
     * 회사 근태 목록 반환
     */
    return getCompanyAttendanceList(corp_no, type)
}


export const fetchCompanyAttendanceListItems = async (corp_no) => {
    /**
     * 회사 근태목록 반환
     */
    try {
        const resp = await fetchCompanyAttendanceList(corp_no); // API 호출

        // 1:근무시간, 2:휴식시간, 3:정보성, 4:기본 주휴일, 5:소정근로시간, 6:연장제외, 7:연장최대, 8:근무 최소단위 code: 0020
        const companyAttendance_worktime = resp.filter(item => item.laborType === '0001');
        const companyAttendance_resttime = resp.filter(item => item.laborType === '0002');
        const companyAttendance_info = resp.filter(item => item.laborType === '0003');
        const companyAttendance_weekend = resp.find(item => item.laborType === '0004');
        const companyAttendance_cwh = resp.find(item => item.laborType === '0005');
        const companyAttendance_extend_exclude = resp.find(item => item.laborType === '0006');
        const companyAttendance_extend_max = resp.find(item => item.laborType === '0007');
        const companyAttendance_min_unit = resp.find(item => item.laborType === '0008');

        return {
            worktime: companyAttendance_worktime,
            resttime: companyAttendance_resttime,
            info: companyAttendance_info,
            weekend: companyAttendance_weekend,
            cwh: companyAttendance_cwh,
            extend_exclude: companyAttendance_extend_exclude,
            extend_max: companyAttendance_extend_max,
            min_unit: companyAttendance_min_unit
        }
    } catch (error) {
        console.error("근태 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const updateCompanyAttendanceList = (apiData) => {
    /**
     * 회사 근태 목록 수정
     */
    return putCompanyAttendanceList(apiData)
}


export const fetchAttendanceCodeList = async () => {
    /**
     * 근태 코드 목록 반환
     */
    try {
        const data = await fetchCodeList(["0031", "0033", "0034"]); // API 호출
        const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0031 = resp.filter((item) => item.category === "0031" && item.subcategory !== "0000").map(item => {
            const { category, ...rest } = item;
            return renameKeys(rest, menuItemKeyMap);
        })
        const menuItems0033 = resp.filter((item) => item.category === "0033" && item.subcategory !== "0000").map(item => {
            const { category, ...rest } = item;
            return renameKeys(rest, menuItemKeyMap);
        })
        const menuItems0034 = resp.filter((item) => item.category === "0034" && item.subcategory !== "0000").map(item => {
            const { category, ...rest } = item;
            return renameKeys(rest, menuItemKeyMap);
        })

        return {
            scheduleMenuItems: menuItems0031,
            atendJdgmntMenuItems: menuItems0033,
            lvofcJdgmntMenuItems: menuItems0034,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("근태 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompanySalaryList = async (corp_no, salaryItemType) => {
    /**
     * 회사 급여 목록 반환
     */
    // return getCompanySalaryList(corp_no)
    const resp = await getCompanySalaryList(corp_no, { salaryItemType: salaryItemType })
    if (resp) {
        const salary_item_info = resp.filter(item => item.salaryTypeStr !== '기준 항목')
        console.log("salary_item_info", salary_item_info)
        return salary_item_info
    } else {
        return []
    }
}

export const fetchCompanySalaryListBasic = async (corp_no, salaryItemType) => {
    /**
     * 회사 급여 목록 기준 항목 반환
     */
    const resp = await getCompanySalaryList(corp_no, { salaryItemType: salaryItemType })

    if (resp) {
        const basic_info = resp.filter(item => item.salaryTypeStr === '기준 항목')
        return basic_info
    } else {
        return []
    }
}

export const fetchCompanySalaryItemList = async (corp_no, salaryItemType, salaryTypeStr, basicYn) => {
    /**
     * 회사 급여 목록 반환 - 급여 항목 추가가 용
     */
    // return getCompanySalaryList(corp_no)
    const resp = await getCompanySalaryList(corp_no, { salaryItemType: salaryItemType, salaryTypeStr: salaryTypeStr, basicYn: basicYn })
    if (resp) {
        const salary_item_info = resp.filter(item => item.salaryTypeStr !== '기준 항목')
        console.log("salary_item_info", salary_item_info)
        return salary_item_info
    } else {
        return []
    }
}

export const fetchCompanySalaryTypeMenuItems = async () => {
    /**
     * 회사 급여 타입 목록 MenuItems 형태로 반환
     */
    const resp = await fetchCodeList(["0016"])
    const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }
    const menuItems = resp.code_list.filter(item => item.category === "0016" && item.subcategory !== "0000").map((item) => renameKeys(item, menuItemKeyMap))
    return menuItems
}

export const createCompanySalary = (apiData) => {
    /**
     * 회사 급여 목록 생성
     */
    return postCompanySalaryList(apiData)
}

export const updateCompanySalary = (apiData) => {
    /**
     * 회사 급여 목록 수정
     */
    return putCompanySalaryList(apiData)
}

export const deleteCompanySalary = (apiData) => {
    /**
     * 회사 급여 목록 삭제
     */
    return deleteCompanySalaryList(apiData)
}

export const fetchCompanyHolidayList = (corp_no) => {
    /**
     * 회사 공휴일 목록 반환
     */
    return getCompanyHolidayList(corp_no)
}

export const createCompanyHoliday = (apiData) => {
    /**
     * 회사 공휴일 목록 생성
     */
    return postCompanyHolidayList(apiData)
}

export const updateCompanyHoliday = (apiData) => {
    /**
     * 회사 공휴일 목록 수정
     */
    return putCompanyHolidayList(apiData)
}

export const deleteCompanyHoliday = (apiData) => {
    /**
     * 회사 공휴일 목록 삭제
     */
    return deleteCompanyHolidayList(apiData)
}

// -----------------------------------------------
// Attendance
// -----------------------------------------------
export const fetchAttendanceTag = (atend_no) => {
    /**
     * 근태 태그 조회
     */
    return getAttendanceTag(atend_no)
}

export const fetchAttendanceTagStatus = () => {
    /**
     * 근태 태그 상태 조회
     * 반환 : hasCheckedIn
     */
    return getAttendanceTag()
}

export const createAttendanceTag = (apiData) => {
    /**
     * 근태 태그 생성
     */
    return postAttendanceTag(apiData)
}

export const fetchAttendanceTagList = (str, end, employeeNos) => {
    /**
     * 근태 태그 목록 반환 - 출퇴근 기록 반환
     */
    return getAttendanceTagList({ str: str, end: end, employeeNos: employeeNos })
}

export const fetchAttendanceDailyWorks = (str, end, employeeNos) => {
    /**
     * 사원 일별 근태 조회
     */
    return getAttendanceDailyWorks({ str: str, end: end, employeeNos: employeeNos })
}


export const fetchAttendanceDailyWork = (empl_no, workDate) => {
    /**
     * 사원 일별 근태 조회 - 1건
     */
    return getAttendanceDailyWork(empl_no, workDate)
}

export const updateAttendanceDailyWork = (empl_no, formData) => {
    /**
     * 사원 일별 근태 수정
     */

    const formattedWorkDate = formData.workDate ?
        (typeof formData.workDate === 'string' ? formData.workDate : format(formData.workDate, 'yyyy-MM-dd'))
        : undefined;

    const formattedAtendTime = formData.atendTime ?
        (typeof formData.atendTime === 'string' ? formData.atendTime : format(formData.atendTime, 'HH:mm'))
        : undefined;

    const formattedLvofcTime = formData.lvofcTime ?
        (typeof formData.lvofcTime === 'string' ? formData.lvofcTime : format(formData.lvofcTime, 'HH:mm'))
        : undefined;

    const formattedGnot = formData.gnot ?
        (typeof formData.gnot === 'string' ? formData.gnot : format(formData.gnot, 'HH:mm'))
        : undefined;

    const formattedRtn = formData.rtn ?
        (typeof formData.rtn === 'string' ? formData.rtn : format(formData.rtn, 'HH:mm'))
        : undefined;

    const formattedLatenTime = formData.latenTime ?
        (typeof formData.latenTime === 'string' ? formData.latenTime : format(formData.latenTime, 'HH:mm'))
        : undefined;

    const formattedGnotTime = formData.gnotTime ?
        (typeof formData.gnotTime === 'string' ? formData.gnotTime : format(formData.gnotTime, 'HH:mm'))
        : undefined;

    const formattedElpdAtend = formData.elpdAtend ?
        (typeof formData.elpdAtend === 'string' ? formData.elpdAtend : format(formData.elpdAtend, 'HH:mm'))
        : undefined;

    const formattedExtnWork = formData.extnWork ?
        (typeof formData.extnWork === 'string' ? formData.extnWork : format(formData.extnWork, 'HH:mm'))
        : undefined;

    const formattedExtnNightWork = formData.extnNightWork ?
        (typeof formData.extnNightWork === 'string' ? formData.extnNightWork : format(formData.extnNightWork, 'HH:mm'))
        : undefined;

    const formattedNightWork = formData.nightWork ?
        (typeof formData.nightWork === 'string' ? formData.nightWork : format(formData.nightWork, 'HH:mm'))
        : undefined;

    const formattedHdayWork = formData.hdayWork ?
        (typeof formData.hdayWork === 'string' ? formData.hdayWork : format(formData.hdayWork, 'HH:mm'))
        : undefined;

    const formattedHdayExtnWork = formData.hdayExtnWork ?
        (typeof formData.hdayExtnWork === 'string' ? formData.hdayExtnWork : format(formData.hdayExtnWork, 'HH:mm'))
        : undefined;

    const formattedHdayNightWork = formData.hdayNightWork ?
        (typeof formData.hdayNightWork === 'string' ? formData.hdayNightWork : format(formData.hdayNightWork, 'HH:mm'))
        : undefined;

    const formattedHdayExtnNightWork = formData.hdayExtnNightWork ?
        (typeof formData.hdayExtnNightWork === 'string' ? formData.hdayExtnNightWork : format(formData.hdayExtnNightWork, 'HH:mm'))
        : undefined;

    const formattedRealWork = formData.realWork ?
        (typeof formData.realWork === 'string' ? formData.realWork : format(formData.realWork, 'HH:mm'))
        : undefined;

    const formattedNormalWork = formData.normalWork ?
        (typeof formData.normalWork === 'string' ? formData.normalWork : format(formData.normalWork, 'HH:mm'))
        : undefined;

    const formattedBreakTime = formData.breakTime ?
        (typeof formData.breakTime === 'string' ? formData.breakTime : format(formData.breakTime, 'HH:mm'))
        : undefined;

    const formattedHdayPayWork = formData.hdayPayWork ?
        (typeof formData.hdayPayWork === 'string' ? formData.hdayPayWork : format(formData.hdayPayWork, 'HH:mm'))
        : undefined;

    const formmatedFormData = {
        workDate: formattedWorkDate,
        workSch: formData.workSch || undefined,
        atendTime: formattedAtendTime,
        lvofcTime: formattedLvofcTime,
        gnot: formattedGnot,
        rtn: formattedRtn,
        atendJdgmntCode: formData.atendJdgmntCode || undefined,
        lvofcJdgmntCode: formData.lvofcJdgmntCode || undefined,
        latenTime: formattedLatenTime,
        gnotTime: formattedGnotTime,
        elpdAtend: formattedElpdAtend,
        extnWork: formattedExtnWork,
        extnNightWork: formattedExtnNightWork,
        nightWork: formattedNightWork,
        hdayWork: formattedHdayWork,
        hdayExtnWork: formattedHdayExtnWork,
        hdayNightWork: formattedHdayNightWork,
        hdayExtnNightWork: formattedHdayExtnNightWork,
        realWork: formattedRealWork,
        normalWork: formattedNormalWork,
        breakTime: formattedBreakTime,
        hdayPayWork: formattedHdayPayWork,
    }
    console.log(formmatedFormData)
    return postAttendanceDailyWork(empl_no, formmatedFormData)
}


export const fetchAttendanceManagement = (month, userNo) => {
    /**
     * 근태 관리 조회
     */
    return getAttendanceManagement(month, userNo)
}

export const createAttendanceManagement = (month, userNo) => {
    // 근태 관리 생성
    return postAttendanceManagement(month, userNo)
}

export const updateAttendanceManagement = (apiData) => {
    /**
     * 근태 관리 수정
     */
    return putAttendanceManagement(apiData)
}


export const fetchCalTime = (empl_no, formData) => {
    /**
     * 근태 관리 계산
     */
    const formattedWorkDate = formData.workDate ?
        (typeof formData.workDate === 'string' ? formData.workDate : format(formData.workDate, 'yyyy-MM-dd'))
        : undefined;

    const formattedAtendTime = formData.atendTime ?
        (typeof formData.atendTime === 'string' ? formData.atendTime : format(formData.atendTime, 'HH:mm'))
        : undefined;

    const formattedLvofcTime = formData.lvofcTime ?
        (typeof formData.lvofcTime === 'string' ? formData.lvofcTime : format(formData.lvofcTime, 'HH:mm'))
        : undefined;

    const formattedGnot = formData.gnot ?
        (typeof formData.gnot === 'string' ? formData.gnot : format(formData.gnot, 'HH:mm'))
        : undefined;

    const formattedRtn = formData.rtn ?
        (typeof formData.rtn === 'string' ? formData.rtn : format(formData.rtn, 'HH:mm'))
        : undefined;

    const workSch = formData.workSch ? formData.workSch : '0001';

    return getCalTime(empl_no, formattedWorkDate, formattedAtendTime, formattedLvofcTime, formattedGnot, formattedRtn, workSch)
}


// -----------------------------------------------
// Salary
// -----------------------------------------------
export const fetchSalaryManagement = (month, companyNo, employeeNo, paymentType) => {
    /**
     * 급여 관리 조회
     */
    return getSalaryManagement({ month: month, companyNo: companyNo, employeeNo: employeeNo, paymentType: paymentType })
}

export const createSalaryManagement = (month, employeeNo, paymentType) => {
    /**
     * 급여 관리 생성
     */
    const apiData = {
        month: month,
        employeeNo: employeeNo,
        paymentType: paymentType
    }
    return postSalaryManagement(apiData)
}

export const updateSalaryManagement = (apiData) => {
    /**
     * 급여 관리 수정
     */
    return putSalaryManagement(apiData)
}

export const createSalaryManagementAll = (month, companyNo, overwrite, paymentType) => {
    /**
     * 급여 관리 생성
     */
    const apiData = {
        month: month,
        companyNo: companyNo,
        updateAll: true,
        overwrite: overwrite,
        paymentType: paymentType
    }
    return postSalaryManagement(apiData)
}

export const fetchPaymentList = (month, companyNo, employeeNos, paymentType) => {
    /**
     * 급여 내역 조회
     */
    return getPaymentList(month, companyNo, employeeNos, paymentType)
}

export const fetchPaymentYearList = (year, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const year_str = format(year, 'yyyy')
    return getPaymentYearList(year_str, paymentType)
}

export const fetchTransferList = (yearMonth, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const yearMonth_str = format(yearMonth, 'yyyyMM')
    return getTransferList(yearMonth_str, paymentType)
}

export const fetchLeavePaymentList = (year, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const year_str = format(year, 'yyyy')
    return getLeavePaymentList(year_str, paymentType)
}


export const fetchCalcEncpnd = (type, encpnd, calcDate) => {
    /**
     * 연차 계산
     */
    return getCalcEncpnd(type, encpnd, calcDate)
}

export const fetchRetirementPensionList = (yearMonth) => {
    /**
     * 퇴직연금 내역 조회
     */
    yearMonth = format(yearMonth, 'yyyy-MM')
    return getRetirementPensionList(yearMonth)
}

export const fetchDepartureList = (yearMonth) => {
    /**
     * 퇴직연금 내역 조회
     */
    yearMonth = format(yearMonth, 'yyyy-MM')
    return getDepartureList(yearMonth)
}

export const fetchInsuranceRate = () => {
    /**
     * 보험 공제율 조회
     */
    return getInsuranceRate()
}

export const fetchSalaryLeaveList = (year) => {
    /**
     * 연차 목록 조회
     */
    year = format(year, 'yyyy')
    return getSalaryLeaveList(year)
}



export const fetchESystemCodeListMenuItems = async () => {
    /**
     * 전자결재 코드 목록 반환
     */
    try {
        // 큰 카테고리 조회
        const data = await fetchCodeList(["0052"]); // API 호출
        const menuItemKeyMap = { subcategory: 'key', value: 'text', desc: 'value' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0052 = resp.filter((item) => item.category === "0052" && item.subcategory !== "0000").map(item => renameKeys(item, menuItemKeyMap))

        // 작은 카테고리 조회
        const valueList = resp.filter((item) => item.category === "0052" && item.subcategory !== "0000").map(item => item.desc);
        const subTypeData = await fetchCodeList(valueList);
        const subTypeResp = subTypeData.code_list
        const subTypeKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        // 작은 카테고리 딕셔너리 생성
        const subTypeDict = {};
        valueList.forEach(async (value) => {
            const codeData = subTypeResp.filter((item) => item.category === value && item.subcategory !== "0000").map(item => renameKeys(item, subTypeKeyMap))
            subTypeDict[value] = codeData;
        });

        return {
            draftType: menuItems0052,
            draftTypeSub: subTypeDict,
            valueList: valueList,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("전자결재 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const createESystemForm = (apiData) => {
    /**
     * 전자결재 기안 생성
     */
    const formattedApiData = {
        ...apiData,
        startDate: apiData.startDate ? format(apiData.startDate, 'yyyy-MM-dd HH:mm') : undefined,
        endDate: apiData.endDate ? format(apiData.endDate, 'yyyy-MM-dd HH:mm') : undefined
    }
    return postESystemForm(formattedApiData)
}


export const fetchESystemList = async (pageType) => {
    /**
     * 전자결재 목록 조회
     */

    if (pageType === 'leave') {

    } else if (pageType === 'vacation') {

    } else if (pageType === 'half-leave') {

    } else if (pageType === 'trip') {

    } else if (pageType === 'edu') {

    } else if (pageType === 'over') {

    } else if (pageType === 'absence') {

    }
    return getESystemList(pageType)
}

export const fetchBeaconList = (corp_no) => {
    /**
     * 등록된 비콘 조회
     */
    return getBeaconList(corp_no)
}

export const fetchBeaconDetail = (corp_no) => {
    /**
     * 등록된 비콘 조회
     */
    return getBeaconDetail(corp_no)
}

export const createBeacon = (beaconData) => {
    /**
     * 비콘 등록
     */
    return postBeaconInsert(beaconData);
}

export const fetchBeaconByName = (no) => {
        /**
     * 비콘정보 검색
     */
    return getBeaconDetailByName(no);
}

export const updateBeacon = (beaconData) => {
        /**
     * 비콘 업데이트
     */
    return postupdateBeacon(beaconData);
}

export const deleteBeacon = (no) => {
    /**
 * 비콘 업데이트
 */
return postdeleteBeacon(no);
}

export const fetchMobileList = (corp_no) => {
    /**
     * 등록된 비콘 조회
     */
    return getMobileList(corp_no)
}

export const fetchMobileByName = (no) => {
    /**
 * 비콘정보 검색
 */
return getMobileDetailByName(no);
}

export const deleteMobile = (no) => {
/**
* 비콘 업데이트
*/
return postdeleteMobile(no);
}